import {Action} from "redux-actions";
import {CATEGORIES_FETCHED, CATEGORY_CREATED, CATEGORY_SORT_ORDER_UPDATED, CATEGORY_UPDATED} from "./actionType";
import {OnFailure, OnSuccess, OnSuccessData} from "../actionHelpers";
import {Dispatch} from "redux";
import {api} from "../../../api/api";
import DictionaryItem from "../../../model/dictionary/DictionaryItem";

/**
 * Categories fetch successful action.
 * @param {DictionaryItem[]} categories fetched categories.
 * @return {Action<CATEGORIES_FETCHED>}
 */
export function categoriesFetched(categories: DictionaryItem[]): Action<CATEGORIES_FETCHED> {
	return {type: CATEGORIES_FETCHED, payload: {categories}}
}

/**
 * Category create successful action.
 * @param {DictionaryItem} category created category.
 * @return {Action<CATEGORY_CREATED>}
 */
export function categoryCreated(category: DictionaryItem): Action<CATEGORY_CREATED> {
	return {type: CATEGORY_CREATED, payload: {category}}
}

/**
 * Category update successful action.
 * @param {DictionaryItem} category updated category.
 * @return {Action<CATEGORY_UPDATED>}
 */
export function categoryUpdated(category: DictionaryItem): Action<CATEGORY_UPDATED> {
	return {type: CATEGORY_UPDATED, payload: {category}}
}

/**
 * Update category sort order successful action.
 * @param {Array<DictionaryItem>} categories
 * @return {Action<CATEGORY_SORT_ORDER_UPDATED>}
 */
function categoriesSortOrderUpdated(categories: Array<DictionaryItem>): Action<CATEGORY_SORT_ORDER_UPDATED> {
	return {type: CATEGORY_SORT_ORDER_UPDATED, payload: {categories}};
}

/**
 * Fetch categories action.
 */
export function fetchCategories(onSuccess: OnSuccessData<DictionaryItem[]>, onFailure: OnFailure) {
	return function(dispatch: Dispatch<any>) {
		api.instance.categoryApi.fetchCategories().then((categories: DictionaryItem[]) => {
			onSuccess(categories);
			dispatch(categoriesFetched(categories))
		}).catch(onFailure);
	};
}

/**
 * Create category.
 * @param category
 * @param onSuccess
 * @param onFailure
 */
export function createCategory(category: DictionaryItem, onSuccess: OnSuccess, onFailure: OnFailure) {
	return function(dispatch: Dispatch<any>) {
		api.instance.categoryApi.createCategory(category.toJson()).then(category => {
			onSuccess();
			dispatch(categoryCreated(category))
		}).catch(onFailure);
	}
}

/**
 * Update category.
 * @param {string} categoryId Id of category to update.
 * @param category edited category
 * @param {OnSuccess} onSuccess Success callback.
 * @param {OnFailure} onFailure Failure callback.
 */
export function updateCategory(categoryId: string, category: DictionaryItem, onSuccess: OnSuccess, onFailure: OnFailure) {
	return function(dispatch: Dispatch<any>) {
		api.instance.categoryApi.updateCategory(categoryId, category.toJson()).then(category => {
			onSuccess();
			dispatch(categoryUpdated(category))
		}).catch(onFailure);
	}
}

/**
 * Update category sort order.
 * @param categories
 * @param {OnSuccess} onSuccess
 * @param {OnFailure} onFailure
 * @return {(dispatch: Dispatch<any>) => void}
 */
export function updateCategoriesSortOrder(categories: DictionaryItem[],
	onSuccess: OnSuccess,
	onFailure: OnFailure) {
	return function(dispatch: Dispatch<any>) {
		api.instance.categoryApi.updateCategoriesSortOrder(categories.map(c => c.id)).then(() => {
			dispatch(categoriesSortOrderUpdated(categories));
			dispatch(onSuccess);
		}).catch(onFailure);
	};
}